/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

export interface VentureFundsBusinessAngelVariantsDestroy$Params {
  id: number;
}

export function ventureFundsBusinessAngelVariantsDestroy(
  http: HttpClient,
  rootUrl: string,
  params: VentureFundsBusinessAngelVariantsDestroy$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, ventureFundsBusinessAngelVariantsDestroy.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(rb.build({ responseType: 'text', accept: '*/*', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as BakendHttpResponse<void>;
    }),
  );
}

ventureFundsBusinessAngelVariantsDestroy.PATH = '/api/venture_funds/business-angel-variants/{id}/';
